import type { ReactNode } from 'react';
import { PortalHeader } from './PortalHeader';

// The portal shell: shared chrome wrapped around every route (launcher + apps).
export function PortalShell({ children }: { children: ReactNode }) {
  return (
    <div className="min-h-screen flex flex-col">
      <PortalHeader />
      <main className="flex-1 px-4 py-6 md:px-8 md:py-8 max-w-6xl mx-auto w-full">{children}</main>
      <footer className="border-t border-border bg-surface-elevated px-4 md:px-8 py-4">
        <span className="font-(family-name:--font-ui) text-[0.7rem] uppercase tracking-[0.15em] text-muted">
          HMH Apps · internal platform
        </span>
      </footer>
    </div>
  );
}
